import { useTranslations } from "next-intl";
import MenuListButton from "@components/core/MenuListButton";
import { useDislikeProduct } from "@hooks/use-current-user";
import { useOpenAddToUserListOffcanvas } from "@hooks/use-userlists";

function MenuWishlistProductEdit({ product, onActionEnd }) {
  const t = useTranslations("common");

  const dislikeProduct = useDislikeProduct();
  const openAddToUserListOffcanvas = useOpenAddToUserListOffcanvas();

  function openAddToUserListOffcanvasAndClose() {
    openAddToUserListOffcanvas(product);
    onActionEnd();
  }

  function dislikeAndClose() {
    dislikeProduct(product.id);
    onActionEnd();
  }

  return (
    <div className="d-flex flex-column w-100">
      <MenuListButton
        onClick={openAddToUserListOffcanvasAndClose}
        trackingName="AddToListFromOffcanvas"
        className="menu-list-button-desktop-rounded-top"
      >
        {t("userlist.add_to_userlist")}
      </MenuListButton>
      <MenuListButton
        onClick={dislikeAndClose}
        trackingName="RemoveFromWishlistFromOffcanvas"
      >
        {t("userlist.remove_from_wishlist")}
      </MenuListButton>
    </div>
  );
}

export default MenuWishlistProductEdit;
